// eslint-disable-next-line no-restricted-syntax
import React from 'react';

import Bugsnag from '../../../../../lib/bugsnag';

export const BugsnagErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React);
